import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import CustomerNotes from '@/views/checkout/components/customer-notes';

@Component({
    data() {
        return {
            dialog: false,
            customerNotes: ''
        };
    },
    components: {
        CustomerNotes
    }
})
export default class PaymentDescription extends Vue {
    @Prop()
    orderNotes: string;

    @Prop({ default: false })
    editable: boolean;

    @Prop()
    label: string;

    customerNotes: string;
    dialog: boolean;

    @Watch('orderNotes')
    onOrderNotesChanged(notes: string) {
        this.customerNotes = notes;
    }

    @Watch('customerNotes')
    onCustomerNotesChanged(notes: string) {
        this.$emit('update:customerNotes', notes);
    }

    get shortedOrderNotesLimit() {
        return this.$vuetify.breakpoint.xsOnly ? 20 : 70;
    }

    get shortedOrderNotes() {
        return this.orderNotes.slice(0, this.shortedOrderNotesLimit).trim().concat('... ');
    }

    showDialog() {
        this.dialog = !this.dialog;
    }
}
